<template>
	<div>
		<my-dialog :visible.sync="batchpicIsShow" title="批量导入图片" dialog-type="form" :close-on-click-modal="false" @close="closeDialogbatchpic">
			<div class="redTip">
				1、照片必须是 *.zip 格式的压缩文件。
				<br />
				2、图片文件的命名规则为：工号.jpg。
				<br />
				3、人员在系统中存在后，再导入人员照片和签名。
			</div>
			<el-upload
				ref="uploadPhtop"
				class="upload-demo"
				:multiple="false"
				accept=".zip"
				style="padding-left: 10px"
				:action="action"
				:headers="myHeaders"
				:on-success="progress"
				:on-progress="onLoading"
				:auto-upload="true"
			>
				<template #trigger>
					<el-button size="small" type="primary">选取文件</el-button>
				</template>
			</el-upload>
		</my-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			batchpicIsShow: false,
			myHeaders: {},
			batchpiclist: [],
			loading2: false,
			action: "",
			importType: 1
		};
	},
	created() {},
	methods: {
		//批量导入签名/人员照片
		uploadImage(type) {
			this.getToken();
			this.importType = type;
			if (type === 1) {
				this.action = "/api/sysConfig/User/UpdateUserPhotoList";
			} else {
				this.action = "/api/sysConfig/User/UpdateUserSignatureList";
			}
			this.batchpicIsShow = true;
		},
		// 上传文档时组装token
		getToken() {
			let token = localStorage.getItem("logintoken");
			this.myHeaders = {
				Authorization: "Bearer " + token
			};
		},
		//关闭批量导入照片弹框
		closeDialogbatchpic() {
			this.batchpicIsShow = false;
			this.$refs.uploadPhtop.clearFiles();
		},
		// 导入成功回调
		progress(event, file) {
			if (event.code == 1) {
				if (event.data == true) {
					this.$message.success("导入成功");
					this.$parent.getListData();
					this.batchpicIsShow = false;
				}
			} else {
				this.$message({
					type: "error",
					message: event.msg
				});
			}
		},
		// 文件正在导入
		onLoading(event, file) {
			const load = this.$loading({
				lock: true,
				text: "正在导入数据...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.4)"
			});
			if (event.code == 0) {
				load.close();
				this.$message({
					type: "info",
					message: event.msg
				});
			} else {
				load.close();
			}
		}
	}
};
</script>
<style scoped>
.redTip {
	color: red;
	font-size: 12px;
	padding: 10px 10px;
}

.capsule-l {
	width: 100px;
	border-radius: 100px 0 0 100px;
}

.capsule-r {
	width: 100px;
	border-radius: 0 100px 100px 0;
	margin-left: 0;
}
</style>
